import type { ElementType } from "react";

import { ShareSessionToggleSwitch } from "./ShareSessionToggleSwitch";

import { cn } from "@/lib/utils";

export const ShareSessionSettingRow = ({
  icon: Icon,
  label,
  description,
  checked,
  onChange,
}: {
  icon: ElementType;
  label: string;
  description: string;
  checked: boolean;
  onChange: (v: boolean) => void;
}) => (
  <div className="group flex items-center justify-between rounded-lg px-3 py-2.5 transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-800/50">
    <div className="flex items-center gap-3">
      <div
        className={cn(
          "flex h-7 w-7 shrink-0 items-center justify-center rounded-lg transition-colors duration-200",
          checked
            ? "bg-blue-50 text-blue-500 dark:bg-blue-500/10 dark:text-blue-400"
            : "bg-gray-100 text-gray-400 dark:bg-gray-800 dark:text-gray-500",
        )}
      >
        <Icon className="h-3.5 w-3.5" />
      </div>
      <div className="min-w-0">
        <p className="text-sm font-medium leading-tight text-gray-800 dark:text-gray-200">
          {label}
        </p>
        <p className="mt-0.5 text-xs leading-tight text-gray-400 dark:text-gray-500">
          {description}
        </p>
      </div>
    </div>
    <ShareSessionToggleSwitch checked={checked} onChange={onChange} />
  </div>
);
